<template>
  <div>
    <page-header
      title="Edit Approval Workflow"
      :back="'/3pl/Settings/Approval'"
      breadcrumb="Dashboard >> Settings >> Approval >> New Approval Workflow"
    />
    <div class="custom-card">
      <div class="font-semibold text-lg my-3">Module Details</div>

      <div class="flex flex-row justify-between mt-3">
        <div>
          <span class="font-semibold text-sm">Module Name</span>
          <div
            class="border bg-backgroundGrey2 rounded h-10 text-sm font-semibold py-auto"
            style="width: 300px; padding: 8px"
          >
            Organisation
          </div>
        </div>
        <div>
          <span class="font-semibold text-sm">Sub Module</span>
          <div
            class="border bg-backgroundGrey2 rounded h-10 text-sm font-semibold py-auto"
            style="width: 300px; padding: 8px"
          >
            Functional Hierarchy
          </div>
        </div>
        <div>
          <span class="font-semibold text-sm">Action/Form</span>
          <div
            class="border bg-backgroundGrey2 rounded h-10 text-sm font-semibold py-auto"
            style="width: 300px; padding: 8px"
          >
            Commit an edited function
          </div>
        </div>
      </div>

      <hr class="my-3" />
      <div>
        <div class="font-semibold my-4 text-lg">
          Location and Function Settings
        </div>

        <div class="flex flex-row my-4 justify-between">
          <div>
            <label class="text-sm flex flex-row justify-between">
              <span class="font-semibold">Location(s)</span>
              <span>
                <b-form-checkbox> Select All Locations </b-form-checkbox></span
              >
            </label>
            <el-select
              filterable
              v-model="state"
              style="width: 442px; display: block"
              placeholder="Select"
            >
              <el-option label="state.name" value="state.name"> </el-option>
            </el-select>
            <div class="container" style="width:442px;">
              <div class="row">
                <div
                  class="col bg-backgroundGrey2 mx-2 my-2 text-sm p-2 flex flex-row justify-between  rounded"
                  style="white-space: nowrap; width:fit-content; max-width:240px"
                >
                  Swirl Media National Liaison
                  <img
                    class="mx-2 inline-block"
                    width="14px"
                    src="./partials/close.svg"
                    alt=""
                  />
                </div>
                <div
                  class="col bg-backgroundGrey2 mx-2 my-2 text-sm p-2 flex flex-row justify-between  rounded"
                  style="white-space: nowrap; width:fit-content; max-width:240px"
                >
                  Swirl Media 
                  <img
                    class="mx-2 inline-block"
                    width="14px"
                    src="./partials/close.svg"
                    alt=""
                  />
                </div>
                <div
                  class="col bg-backgroundGrey2 mx-2 my-2 text-sm p-2 flex flex-row justify-between  rounded"
                  style="white-space: nowrap; width:fit-content; max-width:240px"
                >
                  Swirl Media National Liaison
                  <img
                    class="mx-2 inline-block"
                    width="14px"
                    src="./partials/close.svg"
                    alt=""
                  />
                </div>
                
              
              </div>
            </div>
          </div>
          <div>
            <label class="text-sm flex flex-row justify-between">
              <span class="font-semibold">Function(s)</span>
              <span>
                <b-form-checkbox> Select All Functions </b-form-checkbox></span
              >
            </label>
            <el-select
              filterable
              v-model="state"
              style="width: 442px; display: block"
              placeholder="Select"
            >
              <el-option label="state.name" value="state.name"> </el-option>
            </el-select>
            <div class="container" style="width:442px;">
              <div class="row">
                <div
                  class="col bg-backgroundGrey2 mx-2 my-2 text-sm p-2 flex flex-row justify-between  rounded"
                  style="white-space: nowrap; width:fit-content; max-width:240px"
                >
                  Swirl Media National Liaison
                  <img
                    class="mx-2 inline-block"
                    width="14px"
                    src="./partials/close.svg"
                    alt=""
                  />
                </div>
                <div
                  class="col bg-backgroundGrey2 mx-2 my-2 text-sm p-2 flex flex-row justify-between  rounded"
                  style="white-space: nowrap; width:fit-content; max-width:240px"
                >
                  Swirl Media 
                  <img
                    class="mx-2 inline-block"
                    width="14px"
                    src="./partials/close.svg"
                    alt=""
                  />
                </div>
                <div
                  class="col bg-backgroundGrey2 mx-2 my-2 text-sm p-2 flex flex-row justify-between  rounded"
                  style="white-space: nowrap; width:fit-content; max-width:240px"
                >
                  Swirl Media National Liaison
                  <img
                    class="mx-2 inline-block"
                    width="14px"
                    src="./partials/close.svg"
                    alt=""
                  />
                </div>
                
              
              </div>
            </div>
          </div>
        </div>
      </div>

      <hr />
      <div class="my-4 font-semibold text-lg">Approval Workflow</div>
      <div class="text-sm">
        This is the final step. Select your prefered workflow and build your
        aprroval trail.
      </div>
      <div>
        <div class="text-success text-base font-semibold my-3">
          Approval Type
        </div>
        <div class="flex flex-row">
          <div class="col-6">
            <span class="font-semibold"
              ><b-form-radio
                v-model="approvalType"
                name="approval-type"
                value="manual"
                >Manual</b-form-radio
              ></span
            >
            <div class="border-l-2 ml-2 border-dashed h-16 p-3 text-sm">
              <div class="">
                Let me select the approvers directly, irrespective of my
                organization’s hierarchy.
              </div>
            </div>
          </div>
          <div class="col-6">
            <span class="font-semibold"
              ><b-form-radio
                v-model="approvalType"
                name="approval-type"
                value="dynamic"
                >Dynamic</b-form-radio
              ></span
            >
            <div class="border-l-2 ml-2 border-dashed h-16 p-3 text-sm">
              <div class="">
                Let me select the approvers directly, irrespective of my
                organization’s hierarchy.
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="text-success text-base font-semibold my-3">Approval Flow</div>
      <manual-flow v-if="approvalType === 'manual'"></manual-flow>
      <dynamic-flow v-if="approvalType === 'dynamic'"></dynamic-flow>
      <hr />

      <div class="flex flex-row my-5 justify-between">
        <base-button background="white" text="Cancle"></base-button>
        <base-button text="Save"></base-button>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/UI/NewPageHeader";
import ManualFlow from "./ManualFlow.vue";
import DynamicFlow from "./DynamicFlow.vue";
export default {
  components: {
    PageHeader,
    ManualFlow,
    DynamicFlow,
  },
  data() {
    return {
      approvalStructure: "manual",

      approvalType: "manual",
    };
  },
  methods: {},
};
</script>

<style scoped>
</style>
